// extracted by mini-css-extract-plugin
module.exports = {"color-amber":"_16dfM","colorAmber":"_16dfM","color-green":"m4jte","colorGreen":"m4jte","color-blue":"_3gJqz","colorBlue":"_3gJqz","color-red":"_32063","colorRed":"_32063"};